export { EloIdealIcon } from './ideal-icon'
